import { imageField } from 'molecules/Image/config';

import type { Input } from '@builder.io/sdk';

export const textWithBackGroundImageSwitchback = [
  {
    name: 'backgroundColor',
    type: 'string',
    enum: ['blue', 'gray', 'teal', 'white'],
    defaultValue: 'white',
  },
  {
    name: 'backgroundSize',
    type: 'string',
    enum: ['large', 'regular'],
    defaultValue: 'regular',
  },
  {
    name: 'contentAlignment',
    type: 'string',
    enum: ['right', 'left'],
    defaultValue: 'left',
    helperText: 'Only comes into effect if backgroundSize is set to regular',
    showIf: "options.get('backgroundSize') === 'regular'",
  },
  {
    name: 'heading',
    type: 'string',
  },

  {
    name: 'body',
    type: 'richText',
  },
  {
    name: 'card',
    type: 'object',
    subFields: [
      {
        name: 'cardTitle',
        type: 'string',
      },
      {
        name: 'cardContent',
        type: 'richText',
      },
      imageField('cardImage'),
    ],
  },
  imageField('backgroundImage'),
  imageField('foregroundImage'),
] as const satisfies DeepReadonly<Input[]>;

const textWithBackGroundImageSwitchbackConfig = {
  name: 'Text With Background Image Switchback',
  inputs: textWithBackGroundImageSwitchback,
};

export type TextWithBackGroundImageSwitchback = GenerateBuilder<typeof textWithBackGroundImageSwitchback>;

export default textWithBackGroundImageSwitchbackConfig;
